import {memoize as _memoize} from 'lodash';

const keyResolver = (...args: unknown[]) => JSON.stringify(args);

const memoize: (<T, A = unknown, B = unknown, C = unknown, D = unknown>(func: (a?: A, b?: B, c?: C, d?: D) => T) => (a?: A, b?: B, c?: C, d?: D) => T) = (func) => _memoize(func, keyResolver);

export default memoize;